export default "__VITE_PUBLIC_ASSET__99c53ab9__"